import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=9503afac&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"
import style0 from "./Cookies.vue?vue&type=style&index=0&id=9503afac&prod&lang=scss&scoped=true"
import style1 from "./Cookies.vue?vue&type=style&index=1&id=9503afac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9503afac",
  null
  
)

export default component.exports